import * as angular from 'angular';

class BusinessPromoForSpacesController {
  static $inject = [];

  constructor() {}
}

const BusinessPromoForSpacesComponent: angular.IComponentOptions = {
  controller: BusinessPromoForSpacesController,
  controllerAs: 'ctrl',
  bindings: {
    orgUsername: '<',
  },
  template: `
    <aside class="business-promo business-promo-for-spaces">

      <!-- Illustration -->
      <figure>
        <capra-icon icon="illo-move-to" width="126px" height="69px"></capra-icon>
      </figure>
      <!-- @Illustration -->

      <section class="promo-wrapper">

        <!-- Header -->
        <header class="promo-header">
          <h3 class="promo-heading">Upgrade your account</h3>
          <span class="promo-sub-heading">to organize & govern your work</span>
        </header>
        <!-- @Header -->

        <!-- Body -->
        <div class="promo-body">
          <ul class="promo-props">
            <li class="promo-prop icon-check-mark">Create as many spaces as you like</li>
            <li class="promo-prop icon-check-mark">Work separately with private spaces</li>
            <li class="promo-prop icon-check-mark">Limit database access with user roles</li>
          </ul>
        </div>
        <!-- @Body -->

        <!-- Footer -->
        <footer class="promo-footer">
          <a class="promo-cta-link" href="/organizations/{{ctrl.orgUsername}}/start_trial?trk_element_id=4" target="_blank">Learn More.</a>
        </footer>
        <!-- @Footer -->

      </section>
    </aside>
  `,
};

export { BusinessPromoForSpacesComponent };
